import { ENDPOINTS_MASTER } from "@/constants/table-master";
import type { MESSAGE_ERROR_HTTP } from "@/interfaces/http-client";
import type { ResultMasterMap } from "@/interfaces/table-master";
import { httpClient } from "@/lib/httpClientAxios";
import { getApiUxHeaders, getMessageError } from "@/mappings/httpClient";
import { mapToTableMasterOfResponse } from "@/mappings/master-table";
import { FILTER_TYPES_MASTER, type MasterFilter } from "@/types/master-filter";
import type { components } from "@/types/maestros-api";

type MasterResponse = components["schemas"]["MasterResponse"];

const tableMasterError: Partial<MESSAGE_ERROR_HTTP> = {
    'default': 'Hubo un error desconocido al obtener los datos configurables.',
    404: "Datos configurables no encontrado"
};

export const getMasterTable = async (
    filter: MasterFilter = { type: "master" }
): Promise<ResultMasterMap[] | null> => {
    try {
        const { VITE_APP_URL_MASTER_TABLE} = import.meta.env;
        const headers = getApiUxHeaders();
        let endpoint = "";
        const params: Record<string, string | number> = {};
        
        if (filter.type === FILTER_TYPES_MASTER.PARAMETERS) {
            endpoint = ENDPOINTS_MASTER.PARAMETERS;
        } else {
            endpoint = ENDPOINTS_MASTER.MASTER;

            if (filter.codigosTablas) {
                params.codigosTablas = filter.codigosTablas;
            }
            if (filter.codigoPais) {
                params.codigoPais = filter.codigoPais;
            }
        }

        const { data, status_code } = await httpClient.get<MasterResponse>(
            `${VITE_APP_URL_MASTER_TABLE}${endpoint}`,
            { 
                headers,
                params
            },
        );
        if (status_code === 200 && data?.datos) {
            return mapToTableMasterOfResponse(data);
        }

        return null;
    } catch (error) {
        throw new Error(getMessageError(error, tableMasterError));
    }
};
